export default [
  {
    path: 'change_update/:changeId',
    name: 'UpdateChange',
    component: () => import('@/views/Change/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-changes',
      template: 'auth',
    },
  },
  {
    path: 'change_setting/:changeId',
    name: 'SettingChange',
    component: () => import('@/views/Change/UpdateSetting.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-changes',
      template: 'auth',
    },
  },
  {
    path: 'create_change',
    name: 'createChange',
    component: () => import('@/views/Change/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-changes',
      template: 'auth',
    },
  },
  {
    path: 'printing/change',
    name: 'PrintingChange',
    component: () => import('@/views/Printing/Change.vue'),
    props: true,
    meta: {
      name: 'printing-change',
      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'changes',
    name: 'changes',
    component: () => import('@/views/Change/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-change',
      template: 'auth',
    },
  },
  {
    path: 'change-content/:changeId',
    name: 'changeContent',
    component: () => import('@/views/Change/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-change',
      template: 'auth',
    },
  },
  {
    path: 'change-assignment-main/:changeAssignmentId',
    name: 'changeAssignment',
    component: () => import('@/views/Change/Assignment.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-change',
      template: 'auth',
    },
  },
  {
    path: 'change-assignment-result/:changeAssignmentId',
    name: 'changeAssignmentResult',
    component: () => import('@/views/Change/Result.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-change',
      template: 'auth',
    },
  },
  {
    path: 'change-update-basic/:changeId',
    name: 'changeUpdate',
    component: () => import('@/views/Change/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-change',
      template: 'auth',
    },
  },
  {
    path: 'change-update-setting/:changeId',
    name: 'changeUpdateSetting',
    component: () => import('@/views/Change/UpdateSetting.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-change',
      template: 'auth',
    },
  },
  {
    path: 'change-create',
    name: 'changeCreate',
    component: () => import('@/views/Change/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-change',
      template: 'auth',
    },
  },
  {
    path: 'print-change',
    name: 'printChange',
    component: () => import('@/views/Printing/Change.vue'),
    props: true,
    meta: {
      name: 'printing-change',
      middleware: 'auth',
      template: 'printing',
    },
  },
];
